export default __webpack_public_path__ + "static/media/slide-1.2792e4f0.jpeg";